import autoComplete from "@tarekraafat/autocomplete.js";
import findAncestor from "./findAncestor";
import searchController from "@tarekraafat/autocomplete.js/src/controllers/searchController";
const axios = require('axios');


const API_KEY = '338385_ofm16MhbAAWaHSJn';
const AUTO_COMPLETE = 'https://addressright.co.nz/autocomplete.json';
const ADDRESS_ID = 'https://addressright.co.nz/address.json';

export default () => {

    const doms = document.querySelectorAll('input.js-address');

    let controller = null;

    async function getSuggestions(term)
    {
        if (controller) {
            controller.abort();
            controller = null;
        }
        controller = new AbortController();
        const res = await axios.get(AUTO_COMPLETE, {
            signal: controller.signal,
            params: {
                api_key: API_KEY,
                term: term
            }
        });
        return res;
    }

    async function getAddress(id)
    {
        if (controller) {
            controller.abort();
            controller = null;
        }
        controller = new AbortController();
        const res = await axios.get(ADDRESS_ID, {
            signal: controller.signal,
            params: {
                api_key: API_KEY,
                id: id
            }
        });
        return res;
    }


    for (const dom of doms) {

        const form = findAncestor(dom, 'form');
        const name = dom.getAttribute('name');
        let groupName = '';
        if (name.indexOf('[') >= 0) {
            groupName = name.substr(0, name.indexOf('['));
        }
        const id = dom.getAttribute('id');
        let address2 = null;
        let suburb = null;
        let city = null;
        let postcode = null;
        let region = null;

        if (groupName) {
            address2 = form.querySelector('input[name="' + groupName + '[AddressLine2]"]');
            suburb = form.querySelector('input[name="' + groupName + '[State]"]');
            city = form.querySelector('input[name="' + groupName + '[City]"]');
            postcode = form.querySelector('input[name="' + groupName + '[PostalCode]"]');
            region = form.querySelector('input[name="' + groupName + '[Region]"]');

        } else {
            address2 = form.querySelector('input[name="AddressLine2"]');
            suburb = form.querySelector('input[name="State"]');
            city = form.querySelector('input[name="City"]');
            postcode = form.querySelector('input[name="PostalCode"]');
            region = form.querySelector('input[name="Region"]');
        }



        const autoCompleteJS = new autoComplete({
            selector: `#${id}`,
            wrapper: true,
            data: {
                src: async (query) => {
                    if (query.length >= 3) {
                        const res = await getSuggestions(query);
                        const ret = [];
                        for (let item of res.data) {
                            ret.push({
                                id: item.id,
                                label: item.label
                            })
                        }
                        console.log('FOUND ADDRESSES', ret)
                        return ret;
                    }
                    return [];
                },
                keys: ['label'],
                // cache: true
            },
            threshold: 3,
            searchEngine: (query, record) => {
                const matches = searchController(query, record, {
                    mode: 'loose',
                    diacritics: true,
                    highlight: true,
                });
                if (matches) {
                    return matches;
                }
                return record;
            },
            debounce: 300,
            resultItem: {
                highlight: true
            },
            resultsList: {
                maxResults: 15
            },
            events: {
                input: {
                    selection: async (event) => {
                        const value = event.detail.selection.value;
                        const res = await getAddress(value.id);
                        const structuredAddress = res.data.structured_address;

                        const streetAddressParts = [];
                        if (structuredAddress.street_number) {
                            streetAddressParts.push(structuredAddress.street_number);
                        }
                        if (structuredAddress.street_name) {
                            streetAddressParts.push(structuredAddress.street_name);
                        }
                        if (structuredAddress.road_suffix) {
                            streetAddressParts.push(structuredAddress.road_suffix);
                        }
                        if (structuredAddress.road_type) {
                            streetAddressParts.push(structuredAddress.road_type);
                        }

                        dom.value = streetAddressParts.join(' ');
                        address2.value = '';
                        postcode.value = structuredAddress.postcode;
                        suburb.value = structuredAddress.suburb;

                        let cityValue = structuredAddress.region;
                        if (cityValue.indexOf('City') >= 0) {
                            cityValue = cityValue.replace(' City', '');
                        }
                        if (cityValue.indexOf('city') >= 0) {
                            cityValue = cityValue.replace(' city', '');
                        }

                        city.value = cityValue;

                        // if (structuredAddress.town && structuredAddress.town !== structuredAddress.suburb) {
                        //     city.value = structuredAddress.town;
                        //     // region.value = structuredAddress.region;
                        // } else {
                        //     city.value = structuredAddress.region;
                        // }
                    }
                }
            }
        });


    }


}
